// PHASE 2B/B1 — frontend helpers for the BACKEND-owned currency policy.
// No jurisdiction rules live here: the composer consumes
// GET /api/clinic-leads/{lead_id}/currency-policy verbatim.

const SYMBOLS = { EUR: '€', USD: '$', GBP: '£', TRY: '₺' };

export const currencySymbol = (code) => SYMBOLS[code] || (code ? `${code} ` : '');

const POLICY_REASON_KEYS = {
  patient_residence_unresolved: 'offer.currencyPolicy.patientResidenceMissing',
  provider_jurisdiction_unresolved: 'offer.currencyPolicy.providerJurisdictionMissing',
};

export const currencyPolicyReasonKey = (reason) =>
  POLICY_REASON_KEYS[reason] || 'offer.currencyPolicy.unavailable';

const ERROR_CODE_KEYS = {
  CURRENCY_NOT_ALLOWED: 'offer.currencyPolicy.currencyNotAllowed',
  CURRENCY_POLICY_UNAVAILABLE: 'offer.currencyPolicy.unavailable',
  CURRENCY_REQUIRED: 'offer.currencyPolicy.currencyRequired',
};

// Normalises a backend 4xx into a localized string. Accepts both the
// FastAPI `{detail: {...}}` shape and the JSON `{error, detail}` shape.
export const formatOfferError = (err, t, fallback) => {
  const data = err?.response?.data;
  const detail = data?.detail;
  const body = (detail && typeof detail === 'object') ? detail : data;
  const code = body?.error || body?.code;
  if (code && ERROR_CODE_KEYS[code]) {
    const allowed = (body?.allowed_currencies || []).join(', ');
    if (code === 'CURRENCY_NOT_ALLOWED' && allowed === 'TRY') return t('offer.currencyPolicy.mustBeTry');
    return t(ERROR_CODE_KEYS[code], { allowed });
  }
  if (typeof detail === 'string') return detail;
  if (body?.message) return body.message;
  if (typeof body?.detail === 'string') return body.detail;
  return err?.message || fallback;
};
